import { render, staticRenderFns } from "./splitView.vue?vue&type=template&id=e9f2941e&scoped=true&"
import script from "./splitView.vue?vue&type=script&lang=js&"
export * from "./splitView.vue?vue&type=script&lang=js&"
import style0 from "./splitView.vue?vue&type=style&index=0&id=e9f2941e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f2941e",
  null
  
)

export default component.exports